export enum BaseMetadataType {
  DbStringMetadataValueInfos = "DbStringMetadataValueInfos",
  DbStringMultiMetadataValueInfos = "DbStringMultiMetadataValueInfos",
  DbLongMetadataValueInfos = "DbLongMetadataValueInfos",
  DbLongMultiMetadataValueInfos = "DbLongMultiMetadataValueInfos",
  DbDoubleMetadataValueInfos = "DbDoubleMetadataValueInfos",
  DbDoubleMultiMetadataValueInfos = "DbDoubleMultiMetadataValueInfos",
  DbBoolMetadataValueInfos = "DbBoolMetadataValueInfos",
  DbDateTimeMetadataValueInfos = "DbDateTimeMetadataValueInfos",
  DbDateTimeMultiMetadataValueInfos = "DbDateTimeMultiMetadataValueInfos",
  DbAnyObjectMetadataValueInfos = "DbAnyObjectMetadataValueInfos",
  DbAnyObjectMultiMetadataValueInfos = "DbAnyObjectMultiMetadataValueInfos",
  DbGenreMetadataValueInfos = "DbGenreMetadataValueInfos",
  DbAudioChannelsMetadataValueInfos = "DbAudioChannelsMetadataValueInfos",
  DbCastsMetadataValueInfos = "DbCastsMetadataValueInfos",
  DbSynopsesMetadataValueInfos = "DbSynopsesMetadataValueInfos",
  DbTitlesMetadataValueInfos = "DbTitlesMetadataValueInfos",
  DbClipMetadataValueInfos = "DbClipMetadataValueInfos",
  DbLanguageCodeMetadataValueInfos = "DbLanguageCodeMetadataValueInfos",
  DbLanguageCodeMultiMetadataValueInfos = "DbLanguageCodeMultiMetadataValueInfos",
  DbObjectStatusMetadataValueInfos = "DbObjectStatusMetadataValueInfos",
  DbObjectTypeMetadataValueInfos = "DbObjectTypeMetadataValueInfos",
  DbObjectClassMetadataValueInfos = "DbObjectClassMetadataValueInfos",
  DbRatingDescriptorMetadataValueInfos = "DbRatingDescriptorMetadataValueInfos",
  DbSequenceMetadataValueInfos = "DbSequenceMetadataValueInfos",
  DbPairStringStringMetadataValueInfos = "DbPairStringStringMetadataValueInfos",
  DbPairStringStringMultiMetadataValueInfos = "DbPairStringStringMultiMetadataValueInfos",
  DbTerritoryCodeMetadataValueInfos = "DbTerritoryCodeMetadataValueInfos",
  DbGenreMultiMetadataValueInfos = "DbGenreMultiMetadataValueInfos",
  DbTerritoryCodeMultiMetadataValueInfos = "DbTerritoryCodeMultiMetadataValueInfos",
  DbLocalizedLanguageCodeMetadataValueInfos = "DbLocalizedLanguageCodeMetadataValueInfos",
  DbLocalizedLanguageCodeMultiMetadataValueInfos = "DbLocalizedLanguageCodeMultiMetadataValueInfos",
  DbSubtitlesMetadataValueInfos = "DbSubtitlesMetadataValueInfos",
  DbLocalizedDateTimeMultiMetadataValueInfos = "DbLocalizedDateTimeMultiMetadataValueInfos",
  DbLocalizedTitlesMultiMetadataValueInfos = "DbLocalizedTitlesMultiMetadataValueInfos",
  DbLocalizedBoolMultiMetadataValueInfos = "DbLocalizedBoolMultiMetadataValueInfos",
  DbLocalizedCreditsMultiMetadataValueInfos = "DbLocalizedCreditsMultiMetadataValueInfos",
  DbLocalizedRatingMultiMetadataValueInfos = "DbLocalizedRatingMultiMetadataValueInfos",
  DbSpeechToTextMetadataValueInfos = "DbSpeechToTextMetadataValueInfos",
  DbLocalizedRatingReasonMultiMetadataValueInfos = "DbLocalizedRatingReasonMultiMetadataValueInfos",
  DbStringMultiByEpisodeMetadataValueInfos = "DbStringMultiByEpisodeMetadataValueInfos",
}
